import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';
@Component({
  selector: 'nk-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input() public display: 'block' | 'inline' | 'inline-block' = 'block';
  @Input() public text: string | undefined; // String under loading-indicators or nothing
  @Input() public size: SpinnerSize = 'sm'; // One of: md, lg, xl
  @Input() public opaque = false;
  @Input() public legacySpinner = false;
  public sizeMap: Record<SpinnerSize, number> = {
    sm: 15,
    md: 20,
    lg: 40,
    xl: 60,
  };
}
